import { render, staticRenderFns } from "./BaseInventory.vue?vue&type=template&id=fe95f68a&"
import script from "./BaseInventory.vue?vue&type=script&lang=js&"
export * from "./BaseInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports